import { type PimProductWithVariantsV1 } from '@redteclab/api/clients/bully'

// Central accessor to determine whether a product is a medicament.
// Wraps raw flag access to keep component code simple and allow future changes.
export const productAccessorIsMedicament = (
  product: PimProductWithVariantsV1,
): boolean => Boolean(product.flags?.medicament.active)
